import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../styles/max-container-width/max-container-width.style';

export default StyleSheet.create({
  container: {
    paddingTop: 16,
    paddingBottom: 8,
    zIndex: 1,
  },
  accent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  innerContainer: {
    ...maxContainerWidthStyle,
    paddingHorizontal: 15,
  },
});
